import React, { useState, useEffect, PropTypes } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link, isSold } from "@StarberryUtils";
import { Button, Form, Container, Row, Col, Fade } from "react-bootstrap";
import { ShowProcessedImage } from '../../Common/ggfx-client/module/components/show-image';
import imageConfig from "../../../../static/images/config.json"
import PropertyIMG1 from "../../../images/search-result/property-img.jpg";
import HTMLReactParser from 'html-react-parser';
import FsLightbox from 'fslightbox-react';
import { PropertyList } from "./SearchItems";
import AgentPic from "../../../images/agent-pic.jpg";
import { limitedContent } from "../../Common/site/functions";
import "./SearchList.scss";
import _ from "lodash"
import ReactMarkdown from "react-markdown";
// Myaccount
import { SaveItem } from "@starberry/myaccount-website-utils"

const SearchList = (props) => {


  const data = useStaticQuery(graphql`
  query teamQuery {
    glstrapi {
      teams(sort:"createdAt:asc", where:{Publish:true}) {
        id
        Name
        Tile_Image {
          url
          alternativeText
        }
        URL
        Designation
        Email
        Phone 
        NegotiatorId
      }
    }
}
`)
  const teams = data.glstrapi?.teams;
  const [toggler, setToggler] = useState(false);
  const [floorToggler, setFloorToggler] = useState(false);
  const [propImages, setPropImages] = useState([]);

  const formatter = (val) => {
    if (val) {
      return "£ " + new Intl.NumberFormat("en-US", {}).format(val);
    } else {
      return "£ 0"
    }
  }
  const priceTag = (val) => {
    if (!_.isEmpty(val)) {
      return _.startCase(val.split(/(?=[A-Z])/).join(' '));
    } else {
      return ""
    }
  }
  const TeamDetails = (props) => {
    var result = _.find(teams, function (o) { return (o.NegotiatorId === props.negotiatorId); });
    if (!_.isEmpty(result)) {
      return (<div className="contact-agent">
        <div className="contact-agent-photo">
          {result.Tile_Image &&
            <img src={result.Tile_Image.url} alt={result.Tile_Image.alternativeText} />
          }
        </div>
        <div className="contact-agent-info">
          <span className="contact-agent-name">
            <Link to={`/contact/our-team/${result.URL}`}> {result.Name}</Link>
          </span>
          <a
            href={`tel: ${result.Phone}`}
            className="contact-agent-number"
          >
            {result.Phone}
          </a>
        </div>
      </div>)
    } else {
      return null;
    }
  }
  var images = []
  if (!_.isEmpty(props.images)) { 
    props.images.map((img) => { 
       if (!_.isEmpty(img) && !_.isEmpty(img['820x550'])) {
         images.push(img['820x550']);
       }
    })
  } 
  return (
    <React.Fragment>


      <div className="search-item-box">
        <Row>
          <Col lg={7} className="col-left">

            <div className="search-property-img img-zoom">
              <Link onClick={() => props.mycookies.set(props.mysale, props.objectID, { path: '/', maxAge: 300 })}
                to={props.url}
                propid={props.objectID}
              >
                {
                  props.images && props.images.length != 0 ?
                    <ShowProcessedImage images={props.images[0]} attr={{ className: 'mb-0 img-fluid', alt: '' }} transforms={imageConfig.property.searchResults1.sizes} />
                    :
                    <picture>
                      <img src={PropertyIMG1} alt="img" />
                    </picture>

                }
              </Link>
              <div className="property-btns">
                {!_.isEmpty(props.floorplan) &&
                  <Button
                    type="button"
                    variant="link"
                    className="floor-plans"
                    onClick={() => setFloorToggler(!floorToggler)}
                  >
                    <i className="icon-floor"></i>
                  </Button>
                }
                {!_.isEmpty(props.images) &&
                  <Button
                    type="button"
                    variant="link"
                    className="photos_box"
                    onClick={() => setToggler(!toggler)}
                  >
                    <i className="icon-camera"></i> 1/{props.images.length}
                  </Button>
                }
                {(isSold(props.Status)) &&
                  <Button
                    type="button"
                    variant="link"
                    className="photos_box sold-box"
                  >
                    {props.Status=="Sold" ? "Sold STC" : props.Status}
                  </Button>
                }
                {(!_.isEmpty(props.disposal)) && _.toLower(props.disposal) == "auction" &&
                  <Button
                    type="button"
                    variant="link"
                    className="photos_box auction-box"
                  >
                    {_.capitalize(props.disposal)}
                  </Button>
                }

              </div>
            </div>
            {(isSold(props.Status)) ? "" : (
              <SaveItem type="property" pid={props.objectID} userObjects={props.userObjects} >
              <span className="btn-circle-list">
                  <i class="icon-like icon-default"></i>
                  <i class="icon-like-white-fill icon-saved"></i>
              </span>
              </SaveItem>
              ) 
            }
            

          </Col>
          <Col lg={5} className="col-right">
            <div className="search-property-details">
              <span className="search-property-text">
                {(!_.isEmpty(props.PropertyHeading)) &&
                  _.startCase(_.toLower(props.PropertyHeading).replace(/-/g, " ")).replace(/In/g, "in")
                }
              </span>
              <h2>
                <Link to={props.url}>{props.PropertyLocation} </Link>
              </h2>

              <div className="property-price">

                <span>{priceTag(props.priceQualifier)} {formatter(props.PropertyPrice)} {props.searchType === "lettings" ? "Per Calendar Month" : ""}</span>
              </div>
              <div className="property-overview">
                <ul className="d-none d-md-flex">
                  {(props.BedCount != null && props.BedCount != "" && props.BedCount != "0") &&
                    <li>
                      <i className="icon-bedroom"></i> {props.BedCount}{" "}
                      {props.BedCount==1 ? 'Bedroom' : 'Bedrooms'}
                    </li>
                  }
                  {(props.BathCount != null && props.BathCount != "" && props.BathCount != "0") &&
                    <li>
                      <i className="icon-bathroom"></i> {props.BathCount}{" "}
                      {props.BathCount==1 ? 'Bathroom' : 'Bathrooms'}
                    </li>
                  }
                  {(props.PropertyReception != null && props.PropertyReception != "" && props.PropertyReception != "0") &&
                    < li >
                      <i className="icon-reception"></i> {props.PropertyReception}{" "}
                      Reception
                    </li>
                  }
                </ul>
                <ul className="d-flex d-md-none">
                  {(props.BedCount != null && props.BedCount != "" && props.BedCount != "0") &&
                    <li>
                      <i className="icon-bedroom"></i> {props.BedCount} Bed
                    </li>
                  }
                  {(props.BathCount != null && props.BathCount != "" && props.BathCount != "0") &&
                    <li>
                      <i className="icon-bathroom"></i> {props.BathCount}{" "}
                      Bath
                    </li>
                  }
                  {(props.PropertyReception != null && props.PropertyReception != "" && props.PropertyReception != "0") &&
                    < li >
                      <i className="icon-reception"></i> {props.PropertyReception}{" "}
                      Reception
                    </li>
                  }
                </ul>
              </div>
              <div className="property-description d-none d-md-block">
                {props.PropertyDescription &&
                  <p>
                    {`${HTMLReactParser(limitedContent(props.PropertyDescription.replace(/<br\s*\/?>/gi, ' '), 450))}`}
                    {props.PropertyDescription.length >= 450 &&
                      <Link to={props.url} className="readmore">Read More</Link>
                    }

                  </p>
                }
              </div>
              {props.negotiatorId &&
                <TeamDetails negotiatorId={props.negotiatorId} />
              }


            </div>
          </Col>
        </Row>
      </div>

      {
        !_.isEmpty(images) &&
        <FsLightbox
          toggler={toggler}
          sources={images}
          type='image'

        />
      }
      {
        !_.isEmpty(props.floorplan) &&
        <FsLightbox
          toggler={floorToggler}
          sources={[props.floorplan.url]}
          type='image'

        />
      }


    </React.Fragment >
  );
};

export default SearchList;
